<template>
  <div class="dd-effects__notice" :class="toneClass">
    <div v-if="$slots.icon" class="dd-effects__notice-icon">
      <slot name="icon"></slot>
    </div>
    <div class="dd-effects__notice-body">
      <slot></slot>
    </div>
  </div>
</template>

<script>
export default {
  name: 'EffectFreeNotice',
  props: {
    tone: {
      type: String,
      default: 'default',
    },
  },
  computed: {
    toneClass() {
      return {
        'dd-effects__notice--accent': this.tone === 'accent',
        'dd-effects__notice--warning': this.tone === 'warning',
      };
    },
  },
};
</script>
